// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__N9ig1","sm":"Badge_sm__NluCV","md":"Badge_md__qlw4Z","outline":"Badge_outline__uu9pY","fill":"Badge_fill__iLT5m","content":"Badge_content__9n1ET"};